import { render, staticRenderFns } from "./permissions_list.vue?vue&type=template&id=603bd75e&scoped=true"
import script from "./permissions_list.vue?vue&type=script&lang=js"
export * from "./permissions_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603bd75e",
  null
  
)

export default component.exports